import { render, staticRenderFns } from "./epg-view-switch.vue?vue&type=template&id=df352b36"
import script from "./epg-view-switch.vue?vue&type=script&lang=js"
export * from "./epg-view-switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports